// 景物调色
const jyRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `toning/jy/index${i + 1}`,
  name: `toning/jy/Index${i + 1}`,
  component: () => import(`@/views/edit/toning/jy/index${i + 1}.vue`)
}))
const xtRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `toning/xt/index${i + 1}`,
  name: `toning/xt/Index${i + 1}`,
  component: () => import(`@/views/edit/toning/xt/index${i + 1}.vue`)
}))


import toningIndex from '@/views/edit/toning/index'



export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'toning/index',
        name: 'toningIndex',
        component: toningIndex
      },
    // 景物调色，开始
    ...jyRoutes,
    ...xtRoutes,
    // 景物调色，结束


  ],
};
